import { SUB_APPS } from 'reporting-data/tsTypes/subAppTypes';
import { QUESTIONS } from '../constants/quickAnswerQuestions';
import { ANALYTICS_SUITE_IDS, REVENUE_SUB_APP } from '../constants/templates';
import { AudioInputOutputIcon, BubbleIcon, CallingIcon, CallingMadeIcon, CampaignsIcon, ContactsIcon, CreditCardIcon, CtasIcon, DatabasesIcon, DateIcon, DealsIcon, EmailIcon, EmojiIcon, GaugeIcon, HighlyEngagedLeadIcon, InvoiceIcon, LanguageIcon, LinkIcon, ListsIcon, MenuIcon, MeetingsIcon, PaymentSubscriptionsIcon, SalesQuoteIcon, SequencesIcon, SmsIcon, SocialIcon, SortAmtDescIcon, TabletIcon, TasksIcon, TicketIcon, TimeIcon, TrophyIcon, WebsiteIcon } from 'foundations-assets';
export const RCH_CSAT_SURVEY_ID_QA = 405;
export const RCH_CSAT_SURVEY_ID_PROD = 1116;
export const MISSING_SUBAPP_DESCRIPTIONS = {
  [SUB_APPS.ads]: 'reports.suiteContents.ads.adNetworks.description',
  [SUB_APPS.leadFunnel]: 'reports.collectionHomes.reportDescriptions.leadFunnel',
  [REVENUE_SUB_APP]: 'reports.collectionHomes.reportDescriptions.revenue'
};
export const TAB_ID_TO_ICON = {
  sequences: SequencesIcon,
  meetings: MeetingsIcon,
  calls: CallingIcon,
  tasks: TasksIcon,
  emails: EmailIcon,
  leads: HighlyEngagedLeadIcon,
  leadStages: SortAmtDescIcon,
  lifecycleStageProgression: SortAmtDescIcon,
  pageVisitsToFormSubmissions: HighlyEngagedLeadIcon,
  leadCreationBrokenDownByAdNetwork: CampaignsIcon,
  meetingsThatGeneratedDeals: MeetingsIcon
};
export const SUBAPP_KEY_TO_ICON = {
  [SUB_APPS.attribution]: SalesQuoteIcon,
  [SUB_APPS.ads]: CampaignsIcon,
  [SUB_APPS.leadCapture]: HighlyEngagedLeadIcon,
  [SUB_APPS.marketingEmails]: EmailIcon,
  [SUB_APPS.sources]: CtasIcon,
  [SUB_APPS.pages]: DatabasesIcon,
  [SUB_APPS.utmParameters]: LinkIcon,
  [SUB_APPS.deviceTypes]: TabletIcon,
  [SUB_APPS.geolocation]: LanguageIcon,
  [SUB_APPS.browsers]: WebsiteIcon,
  [SUB_APPS.contactInsights]: ContactsIcon,
  [SUB_APPS.sms]: SmsIcon,
  [SUB_APPS.social]: SocialIcon,
  [SUB_APPS.cta]: CtasIcon,
  [SUB_APPS.topicClusters]: WebsiteIcon,
  [SUB_APPS.callOutcomes]: CallingMadeIcon,
  [SUB_APPS.conversations]: BubbleIcon,
  [SUB_APPS.activities]: TrophyIcon,
  [SUB_APPS.dealsCreatedByRep]: DealsIcon,
  [SUB_APPS.leadFunnel]: SortAmtDescIcon,
  [SUB_APPS.leadResponseTime]: TimeIcon,
  [SUB_APPS.meetingOutcomes]: AudioInputOutputIcon,
  [SUB_APPS.prospectEngagement]: ListsIcon,
  [SUB_APPS.taskOutcomes]: TasksIcon,
  [SUB_APPS.activityStream]: DateIcon,
  [SUB_APPS.timeInDealStage]: TimeIcon,
  [SUB_APPS.changeHistoryDealList]: DateIcon,
  [SUB_APPS.dealJourney]: SortAmtDescIcon,
  [SUB_APPS.waterfall]: SortAmtDescIcon,
  [SUB_APPS.dealPushAnalysis]: GaugeIcon,
  [SUB_APPS.manualForecastTotal]: MeetingsIcon,
  [SUB_APPS.pipelineSnapshots]: DateIcon,
  [SUB_APPS.quotaAttainment]: SalesQuoteIcon,
  [SUB_APPS.manualForecast]: MeetingsIcon,
  [SUB_APPS.weightedPipelineForecast]: MeetingsIcon,
  [SUB_APPS.averageSalesPrice]: DealsIcon,
  [SUB_APPS.lossReasons]: MenuIcon,
  [SUB_APPS.salesBySource]: SalesQuoteIcon,
  [SUB_APPS.dealVelocity]: GaugeIcon,
  [SUB_APPS.dealsWon]: DealsIcon,
  [REVENUE_SUB_APP]: SalesQuoteIcon,
  [SUB_APPS.salesVelocity]: GaugeIcon,
  [SUB_APPS.postSupportCSAT]: EmojiIcon,
  [SUB_APPS.customerEffortScore]: EmojiIcon,
  [SUB_APPS.ticketTimeToClose]: TimeIcon,
  [SUB_APPS.ticketTimeToRespond]: TimeIcon,
  [SUB_APPS.queueTime]: BubbleIcon,
  [SUB_APPS.supportVolume]: TicketIcon,
  [SUB_APPS.ticketTimeInPipeline]: TimeIcon,
  [SUB_APPS.lineItemRevenue]: SalesQuoteIcon,
  [SUB_APPS.customerReplyTime]: TimeIcon,
  [SUB_APPS.customerWaitTime]: TimeIcon,
  [SUB_APPS.ownerReplyCount]: BubbleIcon,
  [SUB_APPS.ownerReplyTime]: TimeIcon,
  [SUB_APPS.ticketReplyCount]: BubbleIcon,
  [SUB_APPS.timeOfDay]: TimeIcon,
  [SUB_APPS.workingHoursAvailability]: TimeIcon,
  [SUB_APPS.maxAvailableRep]: TimeIcon,
  [SUB_APPS.repAvailability]: TimeIcon,
  [SUB_APPS.knowledgeBaseToTickets]: TicketIcon,
  [SUB_APPS.chatbotAndCustomerAgentHandoffs]: TicketIcon,
  [SUB_APPS.chatbotHandoffs]: TicketIcon,
  [SUB_APPS.ticketsToDeals]: DealsIcon,
  [SUB_APPS.agingSummary]: DealsIcon,
  [SUB_APPS.balanceDue]: TimeIcon,
  [SUB_APPS.expectedVsActualRevenue]: GaugeIcon,
  [SUB_APPS.invoiceStatus]: InvoiceIcon,
  [SUB_APPS.commerceChurnSubscriptions]: PaymentSubscriptionsIcon,
  [SUB_APPS.commerceChurnSubscriptionsCount]: PaymentSubscriptionsIcon,
  [SUB_APPS.commerceNewSubscriptions]: PaymentSubscriptionsIcon,
  [SUB_APPS.commerceNewSubscriptionsCount]: PaymentSubscriptionsIcon,
  [SUB_APPS.grossPaymentRevenue]: CreditCardIcon,
  [SUB_APPS.totalPaymentVolume]: CreditCardIcon,
  [SUB_APPS.paymentCustomers]: CreditCardIcon
};
export const REPORT_SUITE_QUESTIONS = {
  [ANALYTICS_SUITE_IDS.MARKETING]: {
    popular: [QUESTIONS.sourcesSessions, QUESTIONS.formsSubmissions, QUESTIONS.pagesBounceRate],
    other: [QUESTIONS.adNetworkPerformance, QUESTIONS.browsersSessionLength, QUESTIONS.contactsBySource, QUESTIONS.contactsLifecycleStages, QUESTIONS.countriesCustomerConversion, QUESTIONS.deviceTypesBounceRate, QUESTIONS.commonDeviceTypes]
  },
  [ANALYTICS_SUITE_IDS.SALES]: {
    popular: [QUESTIONS.dealsTimeToClose, QUESTIONS.forecastClosedWon, QUESTIONS.salesRepQuotaAttainment],
    other: [QUESTIONS.callCountAndSuccess, QUESTIONS.callCountAndSuccess_v2, QUESTIONS.repConversations, QUESTIONS.highestActivityCount, QUESTIONS.dealsCreated, QUESTIONS.fastestLeadResponseTime, QUESTIONS.fastestLeadResponseTime_v2, QUESTIONS.completedMeetings, QUESTIONS.completedMeetings_v2, QUESTIONS.mostTasksCompleted, QUESTIONS.mostTasksCompleted_v2, QUESTIONS.highestEmailReply]
  },
  [ANALYTICS_SUITE_IDS.SERVICE]: {
    popular: [QUESTIONS.avgTimeToCloseTicket, QUESTIONS.timeToAssignChat, QUESTIONS.ticketsByCategory],
    other: [QUESTIONS.customerSatisfaction, QUESTIONS.ticketTimeInPipeline]
  }
};